import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter, takeUntil } from 'rxjs/operators';
import { SimpleTableComponent } from '../../generals/Components';
import { PageItem } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { CurrencyeditorComponent } from '../currencyeditor/currencyeditor.component';

@Component({
  selector: 'app-pages',
  templateUrl: './currencies.component.html'
})
export class CurrenciesComponent extends SimpleTableComponent<PageItem> {

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'currencies';
  }

  showCurrencyDeleteModal(id: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Pénznem törlése',
        text: 'Biztosan törölni szeretnéd ezt a pénznemet?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      this.apiServiceRef.deleteCurrency(id).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.refreshTable();
      });
    });
  }

  showCurrencyEditorModal(id: number = null): void {
      this.dialogService.open(CurrencyeditorComponent, {
        header: id === null ? 'Pénznem hozzáadása' : 'Pénznem szerkesztése',
        data: {
          id
        }
      });
  }
}
